import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, DialogContent,
    TablePagination, Typography, InputAdornment, IconButton, Tooltip, Tab, Card, CardContent, Tabs
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import styles from '../../styles.module.css';
import PropTypes from 'prop-types';
import Breadcrumb from "../reusableComponent/Breadcrumb";
import { Icon } from '@iconify/react';
import { BootstrapDialog, BootstrapDialogTitle } from "../reusableComponent/BootstrapDialog";
import Customer_Supplier_AdvancePaymentList from "./Customer_Supplier_AdvancePaymentList";
import Customer_Supplier_PaymentList from "./Customer_Supplier_PaymentList";
import Customer_Supplier_PaymentAddTab from "./Customer_Supplier_PaymentAddTab";
import { BackBtn } from "../reusableComponent/BackBtn";
import SalesHome from "../sales/salesHome/SalesHome";
import PurchaseHome from "../purchase/purchaseHome/PurchaseHome";
import PaymentsHome from "./PaymentsHome";

const CustomTab = styled(Tab)(({ theme }) => ({
    minWidth: '9px',
    minHeight: '8px',
    // height:'20px',
    marginRight: '2px',
    // border: '1px solid #ffad33',
    // borderRadius: '10px',
    // backgroundColor: '#008080',
    fontWeight: '400',
    fontSize: '13px',
    color: '#000000',
    padding: '4px 4px 4px 4px',
    letterSpacing: '0.3px',
    wordSpacing: '0.8px',
    textTransform: 'none',
    // '&$selected': {
    //     backgroundColor: 'blue',
    // }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function Customer_Supplier_PaymentListTab(props) {
    let ref = useRef();
    const login_details = sessionStorage.getItem('loginUser');
    const userInfo = JSON.parse(login_details);
    const location = useLocation();

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [open, setOpen] = React.useState(false);
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleClickOpenPopup = () => {
        setOpen(true);
    };

    // const editInfo = urlLocation.state.row;
    const backBtnTab = location.state?.backBtnTab || 0;

    const [selectedTab, setSelectedTab] = useState(backBtnTab);
    console.log(selectedTab)
    const [previousTabs, setPreviousTabs] = useState([]);
    const handleChangeTab = (event, newValue) => {
        setPreviousTabs((prev) => [...prev, selectedTab]);
        setSelectedTab(newValue);
    };

    const handlePreviousTab = () => {
        if (previousTabs.length > 0) {
            const previousTab = previousTabs.pop();
            setSelectedTab(previousTab);
            setPreviousTabs([...previousTabs]);
        }
    };
    var containsPurchase = location.pathname.includes('/purchase/');
    var containsSales = location.pathname.includes('/sales/');
    var containsPayments = location.pathname.includes('/payments/');
    return (
        <>
             <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {containsSales === true ?
                        <Breadcrumb
                            routeSegments={[
                                { name: 'Sales', path: '/sales/' },
                                { name: 'Customer Payment' },
                            ]}
                        />
                        :
                        <Breadcrumb
                            routeSegments={[
                                { name: 'Purchase', path: '/purchase/' },
                                { name: 'Supplier Payment' },
                            ]}
                        />
                    }
                </Box>
            {(containsSales === true) &&
                <SalesHome />
            }
            {(containsPurchase === true) &&
                <PurchaseHome />
            }

            <Paper className={`${styles.list_container}`}>
             
                {/* <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={8} xs={8}>
                            <Typography className={`${styles.page_title}`}>
                                {location.pathname == '/sales/' ? 'Customer Payment List' : 'Supplier Payment List'}
                            </Typography>
                        </Grid>
                        <Grid item md={4} xs={4} style={{ display: 'flex', justifyContent: 'right' }}>
                      
                            <Customer_Supplier_PaymentAddTab />
                        </Grid>
                    </Grid>
                </Box> */}

                <Box sx={{ width: '100%', padding: '0px', paddingTop: '4px' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', maxHeight: '32px', paddingLeft: '1px' }}>
                        <Tabs value={selectedTab} onChange={handleChangeTab} aria-label="basic tabs example"
                            indicatorColor="none"
                            textColor="#000000"
                            TabIndicatorProps={{
                                sx: { backgroundColor: "#ff6600", marginBottom: '17px' }
                            }}
                            variant="scrollable">
                            <CustomTab label={location.pathname == '/sales/customer-payment' ? "Customer Payment" : "Supplier Payment"} {...a11yProps(0)} />
                            <CustomTab label={location.pathname == '/sales/customer-payment' ? "Customer Advance Payment" : "Supplier Advance Payment"} {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedTab} index={0}>
                        <Customer_Supplier_PaymentList currentTab={selectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                        <Customer_Supplier_AdvancePaymentList currentTab={selectedTab} />
                    </TabPanel>
                </Box>
            </Paper>

        </>
    )
}

export default Customer_Supplier_PaymentListTab;
